export async function getLoggedInUserID() {
    const endpoint = 'https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails'
	
    const response = await fetch(endpoint)

    if (response.status !== 200) {
        throw new Error('User Not Found')
    }

    const { payload: userDetails } = JSON.parse(await response.text())

    return userDetails.guid
}

export function checkIfUserIsPrivate(user) {
    const isUserPrivate = typeof user === 'string'
    return isUserPrivate
}

//CreatePrivateUser
export function createPrivateUserProfile(userID) {
    const privateUser = {
        _id: userID,
        nickname: 'Private', // Asaf will decide
        imageUrl: 'https://static.wixstatic.com/media/375882_0b1870fe1b7d4a29aeed18549e1c7e3f~mv2.png',
        isPrivate: true,
        isMissing: false
    }

    return privateUser
}

export function checkIfUserIsMissing(user) {
    const isUserMissing = typeof user === 'undefined'

    return isUserMissing
}

//CreatePrivateUser
export function createMissingUserProfile() {
    const privateUser = {
        nickname: 'Missing', // Asaf will decide
        imageUrl: 'https://static.wixstatic.com/media/375882_0b1870fe1b7d4a29aeed18549e1c7e3f~mv2.png',
        isPrivate: false,
        isMissing: true
    }

    return privateUser
}

export function replcaeCurlyBracketsWithImageTags(html) {
    const htmlWithImageTags = html.replace(/{{(.*)}}/gm, '<img src="$1">')

    return htmlWithImageTags
}

export function styleHtmlForDisplay(html) {
    const cssClass = 'font_8'
    const cssStyle = 'line-height:1.5em;font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;'
    const openningPTag = `<p class="${cssClass}">`
    const styledOpenningPTag = `<p class="${cssClass}" style="${cssStyle}">`
    const closingPTag = '</p>'
    let styledHtml
    if (html.includes(openningPTag)) {
        const searchTerm = new RegExp(openningPTag, 'g');
        styledHtml = html.replace(searchTerm, styledOpenningPTag);
    } else {
        styledHtml = `${styledOpenningPTag}${html}${closingPTag}`
    }
    const styledHtmlWithUnderlinedLinks = styledHtml.replace(/\<a/g, '<a style="text-decoration:underline"')
    const styledHtmlWithUnderlinedLinksAndResizedImages = styledHtml.replace(/\<img/g, '<img style="max-width: 100%;"')

    return styledHtmlWithUnderlinedLinksAndResizedImages
}

export function createNextAndPrevRelLinks(query, url, links) {
    const pageNumber = (query.page) ? parseInt(query.page, 10) : 1
    const nextPageNumber = pageNumber + 1
    const prevPageNumber = pageNumber - 1
    const urlWithoutQueryParams = url.split('?')[0]
    const relLinks = [...links]

    const nextUrl = `${urlWithoutQueryParams}?page=${nextPageNumber}`
    relLinks.push({ rel: 'next', href: nextUrl })

    if (prevPageNumber > 0) {
        const prevUrl = (prevPageNumber === 1) ? urlWithoutQueryParams : `${urlWithoutQueryParams}?page=${prevPageNumber}`
        relLinks.push({ rel: 'prev', href: prevUrl })
    }

    return relLinks
}

export function slugifyUrl(string) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export function collectionTagsToUiTags(collectionTags) {
    const uiTags = (collectionTags) ? collectionTags.map(label => ({ label, value: label })) : []
    return uiTags
}

export function trimToWord(text, limit, sufix = '…') {
    const trimmedText = text.substr(0, limit)
    const trimmedTextToWord = trimmedText.substr(0, trimmedText.lastIndexOf(' '))
    const trimmedDescriptionToWordWithSufix = trimmedTextToWord + sufix

    return trimmedDescriptionToWordWithSufix
}